import queryString from 'query-string';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useInitializationObject from '../hooks/use-initialization-object';
import useLoadLearnosityReportsSDK from '../hooks/use-load-learnosity-reports-sdk';
import EndOfLevelUrlObject from '../interfaces/end-of-level-url';
import ResultObject from '../interfaces/result-object';
import { ResultTab } from '../interfaces/result-tab';
import LoadImage from './load-image';

interface ReportsProps {
  sessionId?: string;
  endTestResult: ResultObject;
  onSetActiveTab: (tab: ResultTab) => void;
}

export const Report: React.FC<ReportsProps> = ({ sessionId, endTestResult, onSetActiveTab }) => {
  const { t } = useTranslation();

  const viewFeedbackButtonLabel = t(`button.viewFeedback`);
  const contentButtonLabel = t(`button.keepLearning`);

  const urlParameters = queryString.parse(location.search) as unknown as EndOfLevelUrlObject;

  const type = 'session-detail-by-item';
  const contactId = urlParameters.contactId;
  const elementId = 'learnosity-report';
  const organizationId = urlParameters?.organizationId ?? 'OPEN_ENGLISH_JUNIOR';

  const { getLearnositySDK } = useLoadLearnosityReportsSDK();
  const { getReportsInitializationObject, reportsInitializationObject } = useInitializationObject();

  useEffect(() => {
    const showCorrectAnswers = true;

    if (
      !endTestResult?.status ||
      reportsInitializationObject.loaded !== null ||
      reportsInitializationObject.loading ||
      !sessionId
    ) {
      return;
    }

    getReportsInitializationObject(
      organizationId,
      elementId,
      type,
      contactId,
      sessionId,
      showCorrectAnswers,
    );
  }, [
    endTestResult?.status,
    reportsInitializationObject.loaded,
    reportsInitializationObject.loading,
    getReportsInitializationObject,
    sessionId,
    contactId,
    organizationId,
  ]);

  useEffect(() => {
    if (!reportsInitializationObject?.result) {
      return;
    }
    getLearnositySDK(reportsInitializationObject.result);
  }, [reportsInitializationObject.result, getLearnositySDK]);

  if (reportsInitializationObject.loading) {
    return <LoadImage key="load" />;
  }

  return (
    <div className="result-block pb-40">
      <div id="learnosity-report" />
      <div className="result-buttons-container">
        <button className="oejr-btn outline" onClick={() => onSetActiveTab('feedback')}>
          {viewFeedbackButtonLabel}
        </button>
        <a className="oejr-btn" href={endTestResult.redirectTo} target="_top">
          {contentButtonLabel}
        </a>
      </div>
    </div>
  );
};
